import { render, staticRenderFns } from "./examBatch.vue?vue&type=template&id=6efc0e5d&scoped=true&"
import script from "./examBatch.vue?vue&type=script&lang=js&"
export * from "./examBatch.vue?vue&type=script&lang=js&"
import style0 from "./examBatch.vue?vue&type=style&index=0&id=6efc0e5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc0e5d",
  null
  
)

export default component.exports